export default __webpack_public_path__ + "static/media/pattern.f9342367.png";